import { render, staticRenderFns } from "./gcscc-match-users.vue?vue&type=template&id=906987fc&scoped=true&"
import script from "./gcscc-match-users.vue?vue&type=script&lang=js&"
export * from "./gcscc-match-users.vue?vue&type=script&lang=js&"
import style0 from "./gcscc-match-users.vue?vue&type=style&index=0&id=906987fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906987fc",
  null
  
)

export default component.exports